<template>
  <div  class="el-page-header" :style="{'padding':padding,'borderBottom':borderBottom}">
    <slot name="title">
      <div class="el-page-header__left" @click="back"><i class="el-icon-back"></i>
        <div class="el-page-header__title" style="color:#929292;display:flex;align-items: center;">{{title}}</div>
      </div>
    </slot>
    <slot name="content">
      <div class="el-page-header__content" slot="content">{{content}}</div>
      </slot>
  </div>
</template>

<script>
  export default {
    props: {
      borderBottom:{
        type:String,
        default:'1px solid rgb(227, 227, 227)'
      },
      padding:{
        type:String,
        default:'20px 15px'
      },
      title: {
        type: String,
        default: '返回'
      },
      content: {
        type: String,
        default: ''
      }
    },
    methods: {
      back() {
        this.$emit("back")
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/basic/FwPageBack.vue